import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useClientsList() {
  // Use toast
  const toast = useToast();

  const refClientListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "ID", sortable: true },
    { key: "name_cn", stickyColumn: true, label: "姓名(中文)", sortable: true},
    { key: "name_en", label: "姓名(英文) ", sortable: true },
    { key: "gender.gender", label: "性別" },
    { key: "id_number", label: "身分證" },
    { key: "mobile", label: "手提電話" },
    { key: "date_of_birth", label: "出生日期", sortable: true },
    { key: "age", label: "年齡", sortable: true },
    { key: "address", label: "住宅地址" },
    { key: "tel", label: "住宅電話" },
    // { key: "", label: "尚欠期款" },
    { key: "created_at", label: "申請時間",sortable: true },
    { key: "actions" , label: "操作"},
  ];
  const perPage = ref(10);
  const totalClients = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refClientListTable.value
      ? refClientListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalClients.value,
    };
  });

  const refetchData = () => {
    refClientListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchClients = (ctx, callback) => {
    store
      .dispatch("app-client/fetchClients", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { clients, total } = response.data;
        callback(clients);
        totalClients.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching client list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    fetchClients,
    tableColumns,
    perPage,
    currentPage,
    totalClients,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refClientListTable,
    ability,
    refetchData,
  };
}
